import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingTop: 10,
      paddingBottom: 40,
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
      gap: theme.spacing(3),
      paddingLeft: 0,
      paddingRight: 0,
    },
    card: {
      borderRadius: 8,
      overflow: "hidden",
      backgroundColor: "#fff",
      boxShadow: "0 -4px 12px rgba(0,0,0,0.08), 0 1px 3px rgba(0,0,0,0.12)",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    badgeImageWrap: {
      position: "relative",
      width: "100%",
      maxWidth: 300,
    },
    badgeImage: {
      width: "100%",
      height: "auto",
      display: "block",
      backgroundColor: "#fff",
    },
    badgeOverlay: {
      position: "absolute",
      left: 0,
      right: 0,
      top: "61%",
      textAlign: "center",
      pointerEvents: "none",
    },
    badgeNameOverlay: {
      color: "#fff",
      fontWeight: 700,
      fontSize: "13.5px",
      textShadow: "0 1px 2px rgba(0,0,0,0.5)",
      display: "block",
    },
    badgeNameOverlayLong: {
      fontSize: "12.5px",
    },
    badgeBoxOverlay: {
      width: "100%",
      height: 10,
    },
    badgeYearOverlay: {
      color: "#fff",
      fontWeight: 600,
      fontSize: "13.5px",
    },
    meta: {
      width: "100%",
      paddingBottom: 16,
      paddingLeft: 16,
      paddingRight: 16,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    metaText: {
      fontWeight: 700,
      color: theme.palette.text.primary,
      marginBottom: 4,
      textAlign: "center",
    },
    metaTextInactive: {
      fontWeight: 700,
      color: "#888",
      marginBottom: 4,
      textAlign: "center",
    },
    shareButton: {
      marginTop: 12,
      padding: "8px 20px",
      borderRadius: 8,
      border: `1px solid ${theme.palette.primary.main}`,
      backgroundColor: "transparent",
      color: theme.palette.primary.main,
      fontWeight: 600,
      fontSize: 14,
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "rgba(0,0,0,0.04)",
      },
    },
  })
);

export default useStyles;
